module.exports = __webpack_public_path__ + "img/26cdfd7.jpg";